import {makeAutoObservable} from "mobx";
import {getNotificationStore} from "./NotificationStore";
import {getStore, useStore} from "./index";
import axios from "axios";

export class UserStore {
    store;
    me = {
        _id: 0,
        userId: "",
        userName: "",
        affiliation: "",
        team: 1,
        permissionGroup: {},
        status: false
    };
    permission = {};
    info = {};
    pending = false;

    constructor(store) {
        this.store = store;
        makeAutoObservable(this, {}, {autoBind: true});
    }

    setUser(user) {
        if (user) {
            this.me = user;
            // getSocketStore().connect();
            getNotificationStore().initStore();
            if (user.permissionGroup.name === "마스터") {
                axios.get("/users/permissionGroup?detail=true").then((res) => {
                    const permissionGroups = res.data.data.permissionGroups;
                    this.setPermission(permissionGroups);
                }).catch();
            }
        }
    }

    setPermission(permissionGroups) {
        if (permissionGroups) {
            this.permission = permissionGroups;
        }
    }

    setUserInfo(info) {
        if (info) {
            this.info = info;
        }
    }

    async logOut() {
        if (this.me.userId.length > 0) {
            try {
                await axios.post("/users/signOut");
                localStorage.removeItem("token");
                this.me = {
                    _id: 0,
                    userId: "",
                    userName: "",
                    affiliation: "",
                    team: 1,
                    permissionGroup: {},
                    status: false
                };
            } catch (e) {
                console.log(e);
            }
        } else {
            return Promise.reject({code: "NOT_EXIST_USER"});
        }
    }

    setLoadPending(pending) {
        this.pending = pending;
    }
}

export const useUserStore = () => {
    return useStore().userStore;
}

export const getUserStore = () => {
    return getStore().userStore;
}
